import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string, requestBody: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.USER}/ApiKey/${id}`;
	return axios.put(url, requestBody).toOptionalVoid();
}

export interface Request {
	displayName: string;
	expirationTime: string | null;
}
